module.exports = __webpack_public_path__ + "img/BCG-01.6819a742.png";